import { render, staticRenderFns } from "./productDetailGroup.vue?vue&type=template&id=70460b26&scoped=true"
import script from "./productDetailGroup.vue?vue&type=script&lang=js"
export * from "./productDetailGroup.vue?vue&type=script&lang=js"
import style0 from "./productDetailGroup.vue?vue&type=style&index=0&id=70460b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70460b26",
  null
  
)

export default component.exports